var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":_vm.homeUrl,"title":_vm.appTitle}},[_c('img',{staticClass:"af-app-logo",attrs:{"src":_vm.appIcon,"alt":"Logo"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }